<template>
  <div class="p2" style="background:white">
    <p class="p-4" v-if="loading">Loading</p>
    <div v-else>
      <div>
        <!-- <div v-if="data.type == 'comment'">
                  <div class="border p-2">
                      <p class="m-0 p-0"> <span>{{data.author ? data.author.name ? data.author.name  : 'Anonymous' : 'Anonymous'}} </span><span class="text-lowercase">{{data.description}}</span> on {{data.createdAt | moment('lll')}}</p>
                      <hr class="">
                      <h6 class="">{{data.comment}}</h6>
                  </div>
              </div> -->
        <div class="comment-container py-4 p-4">
          <div
            class="row"
            v-for="(data, index) in agentsCommentData"
            :key="index"
          >
            <div class="col-1 text-center m-0 p-0">
              <i
                v-if="data.type == 'comment'"
                class="font-weight-bold fal fa-comment-alt-lines text-primary icon-header"
              ></i>
              <i
                v-else-if="data.type == 'Followup'"
                class="font-weight-bold fal fa-calendar-check text-info icon-header"
              ></i>
              <i
                v-else-if="data.type == 'Closed'"
                class="font-weight-bold fal fa-check text-danger icon-header"
              ></i>
              <i
                v-else-if="data.type == 'Reopened'"
                class="font-weight-bold fal fa-book-open text-primary icon-header"
              ></i>
              <i
                v-else-if="data.type == 'Tagged'"
                class="font-weight-bold fal fa-tag text-warning icon-header"
              ></i>
              <!-- <b-icon v-if="data.type == 'comment'" icon="chat-square-text-fill" variant="success"></b-icon>
                        <b-icon v-if="data.type == 'followup'" icon="chat-square-text-fill" variant="success"></b-icon> -->
            </div>
            <div class="col-11 pb-5" style="border-left:2px solid #E7ECF0">
              <p class="m-0 p-0">
                <span
                  >{{
                    data.author
                      ? data.author.name
                        ? data.author.name
                        : "Anonymous"
                      : "Anonymous"
                  }} </span
                ><span class="text-lowercase">{{ data.description }}</span>
              </p>
              <h6 v-if="data.comment" class="">{{ data.comment || 'No comment provided'}}</h6>
              <p v-else class="text-muted"><em>No comment provided by the Agent</em></p>
              <span class="text-muted">{{ data.createdAt | moment("lll") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4" v-if="agentsCommentData.length == 0">
        No comments Found
      </div>
    </div>
    <!-- {{data}} -->
    <div class="p-2 py-4 col-md-11 mx-auto">
      <b-form-textarea v-model="comment"></b-form-textarea>
      <div class="my-3 text-right">
        <b-button variant="outline-danger mr-2" v-if="data.otStatus != 'Closed'" @click="changeStatusAndClose">Add Comment and Close</b-button>
        <b-button variant="outline-danger mr-2" v-else-if="data.otStatus === 'Closed'" @click="changeStatusAndReopen">Reopen</b-button>
        <b-button variant="outline-primary" @click="addAgentActivity(false)"
          >Add Comment</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP2 } from "../../axios/http-common";

export default {
  data() {
    return {
      loading: false,
      agentsCommentData: [],
      comment: "",
      data: '',
      status: ''
    };
  },
  props: {
    applicationId: String,
    // data: Object
  },
  created() {
    this.getActivity();
    this.getLoanDetails()
  },
  watch: {
    data(newValue) {
      this.status = newValue.otStatus
    }
  },
  methods: {
    async getLoanDetails () {
      console.log('evoked')
      var { data } = await HTTP2.post(
          "/idfc/get/loan",
          {
            "query": {
              "applicationId" :this.applicationId
            },
          }
        );
        this.data = data.loanData[0]
    },
    async getActivity() {
      try {
        this.loading = true;
        var { data } = await HTTP2.post("get/activity", {
          query: {
            activity_id: this.applicationId,
          },
        });
        this.agentsCommentData = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async changeStatusAndClose() {
      HTTP2.post(
          `/finance/update/loan/prod/${this.applicationId}`,
          {
            otStatus: 'Closed'
          }
        ).then(()=>{
          this.addAgentActivity(true)
          this.getLoanDetails()
        }).catch(err=>{
          console.log(err)
        })
    },
    async changeStatusAndReopen() {
      try {
        HTTP2.post(
          `/finance/update/loan/prod/${this.applicationId}`,
          {
            otStatus: 'Open'
          }
        );
      } catch {
        console.log('Error')
      } finally {
        this.addAgentActivity(false, true)
        this.getLoanDetails()
      }
    },
    async addAgentActivity(closed, reopened) {
      var payload = {}
      if (closed) {
        payload = {
          activity_id: this.applicationId,
          type: "Closed",
          description: "closed this opportunity with comment",
          comment: this.comment,
          author: {
            id: localStorage.getItem("agent_id"),
            name: localStorage.getItem("username"),
            agentToken: localStorage.getItem("agentT"),
          },
        }
      } else if (reopened) {
        payload = {
          activity_id: this.applicationId,
          type: "Reopened",
          description: "reopened this opportunity with comment",
          comment: this.comment,
          author: {
            id: localStorage.getItem("agent_id"),
            name: localStorage.getItem("username"),
            agentToken: localStorage.getItem("agentT"),
          },
        }
      } else {
        payload = {
          activity_id: this.applicationId,
          type: "comment",
          description: "added a comment",
          comment: this.comment,
          author: {
            id: localStorage.getItem("agent_id"),
            name: localStorage.getItem("username"),
            agentToken: localStorage.getItem("agentT"),
          },
        }
      }
      this.$store
        .dispatch("addActivity", payload)
        .then(() => {
          this.comment = ''
          this.getActivity();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // try {
      //     this.loading = true
      //     this.$store.dispatch('addActivity',
      //     {
      //         activity_id: this.applicationId,
      //         type: 'comment',
      //         description: 'added a comment',
      //         comment: this.comment
      //     }
      //     ).then(()=> {
      //         this.getActivity()
      //         this.loading = false
      //     })
      // } catch(error) {
      //     console.log(error)
      // } finally {
      //     this.getActivity()
      //     this.loading = false
      // }
    },
  },
};
</script>

<style>
/* .comment-container {
  max-height: 60vh;
  overflow: scroll;
} */
.icon-header {
  /* background-color: #e7ecf0;
  border-radius: 50%; */
  padding: 10px;
  font-size: 15px;
}
</style>
